(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * @file
 * Global utilities.
 * - Add class for ie Browser
 * - Select2 dropdown
 * - Header scroll effect
 * - Mdoal Popup
 * -
 * -----------
 * - Mega menu
 * - Adding different class in menu (Level 2 and 3)
 * -
 * -
 * -----------
 * - Resize
 * -
 * -
 */

(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.bootstrap_barrio_subtheme = {
    attach: function (context, settings) {
      // Add search value //
      if ("#views-exposed-form-search-search") {
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('=');
        var search_value = hashes[0];
        if (search_value == 'keys') {
          var key = hashes[1];
          var res = key.replace("+", " ");
          var key_split = res.split("&" || "%");
          var key_value = key_split[0];
          var decode_key_value = decodeURIComponent(key_value);
          jQuery(".bef-exposed-form .form-search").val(decode_key_value);
        }
      }
      jQuery('.search-reset-button .form-submit[id^=edit-reset]').on('click keypress', function (e) {
        e.preventDefault();
        location.href = location.origin + location.pathname;
      });

      // Home page, Entire card clickable code
      setTimeout(function () {
        jQuery(".popup-container").each(function () {
          jQuery(this).parents('.key-image').find('img:first').wrap("<div class='key-img-container'></div>");
          jQuery(this).parents('.key-image').find('.key-img-container').append($(this).find('.content-wrapper-parent').html());
          jQuery(this).parents('.key-image').find('a').append($(this).find('.card-body-wrapper-parent').html());
          jQuery(this).remove();
        });
      }, 1500);


      // Sort by by Ajax //
      var bodyClasses = $('body').attr("class").split(/\s+/);
      var localStorageVar = '';

      for (var i = 0; i < bodyClasses.length; i++) {
        if (bodyClasses[i].indexOf("page-node-") > -1) {
          var localStorageVar = bodyClasses[i];
        }
      }

      // Grid-List //
      if (localStorage.getItem(localStorageVar + '_display_type') == null || localStorage.getItem(localStorageVar + '_display_type' == undefined)) {
        localStorage.setItem(localStorageVar + '_display_type', "grid");
      }

      jQuery(".grid-view a").on("click", function () {
        localStorage.setItem(localStorageVar + '_display_type', "grid");
      });
      jQuery(".list-view a").on("click", function () {
        localStorage.setItem(localStorageVar + '_display_type', "list");
      });

      var Type = localStorage.getItem(localStorageVar + '_display_type');


      // RTL Js //
      var html_direction = jQuery('html').attr('dir');
      jQuery("article").each(function () {
        jQuery(this).removeAttr('dir');
        jQuery(this).attr('dir', html_direction);
      });

      // Add class for ie //
      var trident = !!navigator.userAgent.match(/Trident\/7.0/);
      var net = !!navigator.userAgent.match(/.NET4.0E/);
      var IE11 = trident && net
      var IEold = (navigator.userAgent.match(/MSIE/i) ? true : false);
      if (IE11 || IEold) {
        jQuery("body").addClass("ie");
      }

      // Select2 dropdown //
      jQuery(".js-form-item select").select2();

      // Header scroll effect //
      jQuery(window).on('scroll', function () {
        var screenHeight = jQuery(window).scrollTop();

        if (screenHeight >= 85) {
          jQuery("header").addClass("fix-header");
        }
        else {
          jQuery("header").removeClass("fix-header");
        }
      });

      var position = jQuery(window).scrollTop();
      jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll > position) {
          jQuery('header').removeClass('nav-down').addClass('header-up');
        } else {
          jQuery('header').removeClass('header-up').addClass('nav-down');
        }
        position = scroll;
      });

      // Mdoal Popup //
      jQuery(document).ready(function () {
        jQuery(once('append-list', 'body.node--type-landing:not(.path-frontpage')).append('<div class="list-grid-overlay overlay open-sidebar"></div>');

        // Modal open when select on english language //
        $(document).on('hidden.bs.modal', function () {
          if ($('.modal.show').length) {
            $('body').addClass('modal-open');
          }
        });
        $('.checkbox-wrap input').click(function () {
          if ($(this).prop("checked") == true) {
            $.cookie('no_thanks', 'true', { expires: 36500, path: '/' });
          }
          else if ($(this).prop("checked") == false) {
            $.cookie('no_thanks', 'true', { expires: 0, path: '/' });
          }
        });

        // List and Grid active tab //
        jQuery('.result-view-wrapper').removeClass('grid');
        jQuery('.result-view-wrapper').removeClass('list');

        jQuery('.grid-link').removeClass('active');
        jQuery('.list-link').removeClass('active');

        jQuery('.result-view-wrapper').addClass(Type).css('opacity', '1');
        jQuery('.' + Type + '-link').addClass('active');

        setTimeout(function () {
          jQuery('.list-grid-overlay.overlay').remove();
        }, 1500);

        jQuery(once('ajaxloadmore', '.field .js-pager__items.pager .button')).click(function() {
          jQuery('body.node--type-landing:not(.path-frontpage)').append('<div class="list-grid-overlay overlay open-sidebar"></div>');
        });
      });

      // Feedback Form //
      jQuery(once('feat-feedback-bt-open', '.featured-bottom .feedback-actions p a.feedback-open')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.featured-bottom .block-webform').slideToggle("slow");
          jQuery('.featured-bottom .block-webform').toggleClass("show-feedback");
          jQuery('.feedback-actions p:first-child').hide();
          jQuery('.featured-bottom').addClass('feedback-webform-open');
          jQuery('.feedback-actions').addClass('feedback-buttons');
          jQuery('.feedback-wrapper').addClass('feedback-form-open');
          jQuery('.feedback-buttons p:last-child').css('display', 'block');
          jQuery('body').addClass("scroll-hide");
          jQuery('#scrollUp').css('opacity', '0');
        });
      });
      jQuery(once('feat-feedback-bt-close', '.featured-bottom .feedback-actions p a.feedback-close')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.featured-bottom .block-webform').hide();
          jQuery('.feedback-actions p:first-child').show();
          jQuery('.featured-bottom').removeClass('feedback-webform-open');
          jQuery('.feedback-actions').removeClass('feedback-buttons');
          jQuery('.feedback-wrapper').removeClass('feedback-form-open');
          jQuery(this).parent().hide();
          jQuery('body').removeClass("scroll-hide");
          jQuery('#scrollUp').css('opacity', '1');
        });
      });

      // Feedback form hide while click outside //
      jQuery(document).click(function (e) {
        if (!$(e.target).hasClass(".feedback-open") && $(e.target).parents(".featured-bottom").length === 0) {
          jQuery('.feedback-wrapper').hide();
          jQuery('.feedback-actions p:first-child').show();
          jQuery('.feedback-buttons p:last-child').css('display', 'none');
          jQuery('.featured-bottom').removeClass('feedback-webform-open');
          jQuery('.feedback-wrapper').removeClass('feedback-form-open');
          jQuery('body').removeClass("scroll-hide");
          jQuery('#scrollUp').css('opacity', '1');
        }
      });

      // Hide back to scroll button while open feedback form //
      var feedbackform = jQuery(".featured-bottom");
      jQuery(feedbackform).on('click', function () {
        jQuery('#scrollUp').hide();
      });

      jQuery(window).scroll(function () {
        if (jQuery('.feedback-wrapper').hasClass('feedback-form-open')) {
          jQuery('#scrollUp').hide();
        }
        else {
          jQuery('#scrollUp').show();
        }
      });

      // Hide back to scroll button while open sidebar filter //
      var sidebar = jQuery(".more-filter-btn");
      jQuery(sidebar).on('click', function () {
        jQuery('#scrollUp').hide();
      });

      jQuery(window).scroll(function () {
        if (jQuery('.more-filter-wrapper').hasClass('active')) {
          jQuery('#scrollUp').hide();
        }
        else {
          jQuery('#scrollUp').show();
        }
      });


      // MEGA MENU JS //

      // Adding different class in menu (Level 2 and 3) //
      jQuery('ul.menu > li > .submenu').parent().addClass('has-2-level');
      jQuery('ul.menu > li > .submenu li > .submenu').parent().parent().parent().parent().removeClass('has-2-level').addClass('has-3-level');

      // Mobile menu on click add class in body //
      jQuery('.header-mobile .hamburger').on("click", function () {
        jQuery('body').append("<div class='sidemenuopen'></div>");
        jQuery('body').addClass("showmenu");
      });
      jQuery('.header .navbar .hamburger').on("click", function () {
        jQuery('body').find('.sidemenuopen').remove();
        jQuery('body').removeClass("showmenu");
      });

      // Outside click then close overlay for menu //
      var $menu = $('.navbar');
      var $body = $('body');

      if (jQuery('html').attr('dir') == 'rtl') {
        var isRTL = true;
        $(document).mouseup(e => {
          if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            $menu.removeClass('open');
            jQuery('.navbar').find('.submenu').removeClass('open');
            $body.removeClass('showmenu');
            jQuery(".sidemenuopen").remove();
            jQuery('.main-header').find('.menu-header').removeClass("hidden");
            jQuery(".mobile-nav-head").css("height", "65px");
          }
        });
      }
      else {
        var isRTL = false;
        $(document).mouseup(e => {
          if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            $menu.removeClass('open');
            jQuery('.navbar').find('.submenu').removeClass('open');
            $body.removeClass('showmenu');
            jQuery(".sidemenuopen").remove();
            jQuery('.main-header').find('.menu-header').removeClass("hidden");
            jQuery(".mobile-nav-head").css("height", "65px");
          }
        });
      }

      jQuery("ul.menu > li").each(function (e) {
        jQuery(this).children('.we-mega-menu-caption').addClass('caption-level-1').detach().appendTo($(this).children('.submenu'));
      });

      // Responsive main menu js //
      jQuery("ul.menu li a[href$='#']").on("click", function (e) {
        if (jQuery(this).next().hasClass("submenu")) {
          jQuery(this).parents('.main-header').find('.menu-header').addClass("hidden");
        }
      });

      jQuery(".mobile-nav-head .hamburger").on("click", function (e) {
        jQuery(this).siblings('.menu-header').removeClass("hidden");
        jQuery(".mobile-nav-head span.nav-head").remove();
      });

      jQuery("ul.menu > li > .submenu > .back").on("click", function (e) {
        jQuery(".mobile-nav-head").css("height", "65px");
        jQuery(this).parents('.main-header').find('.menu-header').removeClass("hidden");
        jQuery(".mobile-nav-head span.nav-head").remove();
      });
      jQuery(".mobile-nav-head .hamburger").on("click", function (e) {
        jQuery(".mobile-nav-head").css("height", "65px");
      });

      jQuery('.menu-subtext').each(function () {
        if (jQuery(this).text().length > 2) {
          jQuery(this).parent().parent().addClass("subspan");
        }
      });

      jQuery("ul.menu li a[href$='#']").click(function () {
        var txt;
        txt = jQuery(this).siblings(".nav-head").outerHeight() + 35;
        jQuery(".mobile-nav-head").css({
          height: txt,
        });

      });

      jQuery("li .back-icon").click(function () {
        var txt;
        txt = jQuery(this).parents('ul').parents('.dropdown-menu').children('.nav-head').outerHeight() + 35;
        jQuery(".mobile-nav-head").css({
          height: txt,
        });
      });

      // Mega menu in break li //
      jQuery("nav.navbar .submenu .subspan li.other-themes-menu").hover(function () {
        jQuery(this).parent().parent().addClass('menu-height');
      }, function () {
        jQuery(this).parent().parent().removeClass('menu-height');
      });

      if (context === document) {

        jQuery("nav.navbar .has-3-level>.submenu>ul .submenu ul").each(function () {
          var $menu = jQuery(this);
          var items = $menu.children("li").not(".w-100");
          // Divide items into 3 columns
          var column_devide = Math.ceil(items.length / 3);

          // Clear any existing structure to avoid duplication
          $menu.children(".menu-column").contents().unwrap();

          // Group items into columns
          items.each(function (index) {
            var column_index = Math.floor(index);
            if (!$menu.children(".menu-column").eq(column_index).length) {
              jQuery('<div />', { class: 'menu-column' }).appendTo($menu);
            }
            $menu.children(".menu-column").eq(column_index).append(this);
          });

          // Ensure no items are hidden by checking visibility
          $menu.children(".menu-column").each(function () {
            var $column = jQuery(this);
            var hiddenItems = $column.children("li").filter(function () {
              return jQuery(this).css("display") === "none";
            });

            // Make hidden items visible
            if (hiddenItems.length) {
              hiddenItems.css("display", "block");
            }
          });
        });
      }

      // SetTimeout //
      setTimeout(function () {

        // Card slider //
        if (jQuery('html').attr('dir') == 'rtl') {
          var isRTL = true;
        }
        else {
          var isRTL = false;
        }
        jQuery('.home-card-slider .view-content').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          cssEase: 'linear',
          slidesToShow: 4,
          slidesToScroll: 4,
          rtl: isRTL,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
                slidesToScroll: 1,

              }
            }
          ]
        });

        // Get height of each card //
        if (jQuery(window).width() < 992) {
          var lang_selected = jQuery('.lang-dropdown-select-element').find(":selected").val().toUpperCase();
          jQuery('.js-form-item-lang-dropdown-select .select2 .select2-selection__rendered').text(lang_selected);
        }
        else {
          var lang_selected = jQuery('.lang-dropdown-select-element').find(":selected").html();
          jQuery('.js-form-item-lang-dropdown-select .select2 .select2-selection__rendered').text(lang_selected);
        }
      }, 1000);


      //  Window Resize Get height of each card //
      jQuery(window).resize(function () {

        if (jQuery(window).width() < 992) {
          var lang_selected = jQuery('.lang-dropdown-select-element').find(":selected").val().toUpperCase();
          jQuery('.js-form-item-lang-dropdown-select .select2 .select2-selection__rendered').text(lang_selected);
        }
        else {
          var lang_selected = jQuery('.lang-dropdown-select-element').find(":selected").html();
          jQuery('.js-form-item-lang-dropdown-select .select2 .select2-selection__rendered').text(lang_selected);
        }
      });


      $(document).ajaxSuccess(function () {

        // Feedback form height auto after Thank you message //
        if (jQuery('.webform-confirmation').length) {
          jQuery('.webform-confirmation').parents('form').css('height', 'auto');
        }

      });

      setTimeout(function () {
        let searchParams = new URLSearchParams(window.location.search);
        let list_type = searchParams.get('list_type');
        let storedType = localStorage.getItem(localStorageVar + '_display_type');

        if (list_type == 'list' && !isMobileView()) {
          jQuery('.list-link').trigger('click');
        } else {
          if (storedType == 'grid' || list_type == 'grid') {
            jQuery('.grid-link').trigger('click');
          }
        }
      }, 1500);

      function isMobileView() {
        return window.innerWidth <= 767; // Adjust this breakpoint value to suit your needs
      }

      // Active list and grid icon //
      jQuery('.list-link').click(function (event) {
        if (!isMobileView()) {
          event.preventDefault();
          jQuery(this).addClass("active");
          jQuery('.grid-link').removeClass("active");
          jQuery('.result-view-wrapper').removeClass('grid');
          jQuery('.result-view-wrapper').addClass('list');
        }
      });
      jQuery('.grid-link').click(function (event) {
        event.preventDefault();
        jQuery(this).addClass("active");
        jQuery('.list-link').removeClass("active");
        jQuery('.result-view-wrapper').removeClass('list');
        jQuery('.result-view-wrapper').addClass('grid');
      });

      // Focus input for landing pages //
      jQuery(once('exposed-filter-input', '.views-exposed-form .filter-wrapper input')).each(function () {
        jQuery(this).on('blur', function () {
          jQuery(this).parent().toggleClass('is_focused');
        }).on('focus', function () {
          jQuery(this).parent().toggleClass('is_focused');
        })
      });

      // Detach Div in view filter pages //
      function detachcategoryA() {
        if (jQuery(window).width() < 768) {
          jQuery(".detach-div").insertAfter(".more-filter-wrapper .filter-header");
        }
        else {
          jQuery(".detach-div").appendTo(".filter-field-wrapper");
        }
      }
      // Uncomment this function to hide `Filter By` section from page on mobile view.
      // detachcategoryA();
      jQuery(window).bind("orientationchange", function (event) {
        event.preventDefault();
        if (jQuery(window).width() < 768) {
          jQuery(".detach-div").insertAfter(".more-filter-wrapper .filter-header");
        }
        else {
          jQuery(".detach-div").appendTo(".filter-field-wrapper");
        }
      });

      // Image title //
      jQuery('.item-icon img').hover(function () {
        var name = $(this).attr('title');
        console.log(name);
      });

      // Show Result button //
      jQuery(once('form-submit', '.views-exposed-form.bef-exposed-form .submit-action input[type="submit"], .views-exposed-form.bef-exposed-form [data-drupal-selector="edit-submit-show-results"], .views-exposed-form.bef-exposed-form [data-drupal-selector="edit-submit-done"]', context)).click(function(e) {
        jQuery('.views-exposed-form').submit();
      });

      // Search page in page language on click form submit //
      jQuery(".js-facets-widget input[type='checkbox']").change(function () {
        if (this.checked == true) {
          jQuery('.views-exposed-form').submit();
        }
      });

      // Product list filter section JS //
      jQuery('.more-filter-wrapper .btn-done, .filter-over').on('click', function () {
        jQuery('.more-filter-wrapper').removeClass('active');
        jQuery('.filter-over').removeClass('open-sidebar');
        jQuery('html').removeClass('filter-sidebar');
      });

      jQuery('.view-filters .more-filter-btn input').on('click', function () {
        jQuery('.more-filter-wrapper').addClass('active');
        jQuery('.filter-over').addClass('open-sidebar');
        jQuery('html').addClass('filter-sidebar');
      });

      jQuery('[data-drupal-selector="edit-sort-bef-combine"]').change(function () {
        this.form.submit();
      });

      // Color box bg scroll fix Js //
      jQuery(document).bind('cbox_open  ', function () {
        jQuery('body').addClass("showcolormodal");
        jQuery('#scrollUp').hide().css('opacity', '0');
      });

      jQuery(document).bind('cbox_closed', function () {
        jQuery('body').removeClass("showcolormodal");
        jQuery('#scrollUp').show();
        jQuery('#scrollUp').css('opacity', '1');
      });

      // Mobile Filter Button Dark JS //
      if (jQuery(window).width() < 768) {
        var filterButton = jQuery(".more-filter-btn input");
        jQuery(".more-filter-wrapper  input[type='checkbox']").click(function () {
          filterButton.toggleClass("active", jQuery(this).is(":checked"));
        });

        jQuery(".more-filter-wrapper  input[type='text']").on('input change', function () {
          if (jQuery(this).val().length > 0) {
            jQuery(".more-filter-btn input").addClass("active");
          }
          else {
            jQuery(".more-filter-btn input").removeClass("active");
          }
        });
        jQuery(".more-filter-btn input").click(function () {
          jQuery(".bef-slider span").on('click', function () {
            jQuery(".more-filter-btn input").addClass("active");
          });
        });
      }

      jQuery(".feedback-form-open textarea.error").parent().addClass("error-icon");
      // Sidebar Filter toogle JS //
      if (!flagLoad) {
        flagLoad = true;
        setNodeAddCurrency();
      }

      var flagLoad = false;
      var type = jQuery('.type-wrap');
      var genre = jQuery('.genre-wrap');
      var lang = jQuery('.language-wrap');
      var sublang = jQuery('.subtitle-language-wrap');
      var trnslang = jQuery('.trans-language-wrap');

      type.addClass('hide');
      genre.addClass('hide');
      lang.addClass('hide');
      sublang.addClass('hide');
      trnslang.addClass('hide');

      jQuery(once('show-all', '.show-all')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.type-wrap').toggleClass('hide');
          jQuery(this).toggleClass('up-arrow');
        });
      });

      jQuery(once('showgenre-all', '.showgenre-all')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.genre-wrap').toggleClass('hide');
          jQuery(this).toggleClass('up-arrow');
        });
      });

      jQuery(once('showlang-all', '.showlang-all')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.language-wrap').toggleClass('hide');
          jQuery(this).toggleClass('up-arrow');
        });
      });

      jQuery(once('show-sublang-all', '.show-sublang-all')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.subtitle-language-wrap').toggleClass('hide');
          jQuery(this).toggleClass('up-arrow');
        });
      });

      jQuery(once('show-trns-lang-all', '.show-trns-lang-all')).each(function () {
        jQuery(this).on('click', function () {
          jQuery('.trans-language-wrap').toggleClass('hide');
          jQuery(this).toggleClass('up-arrow');
        });
      });

      jQuery(once('facets-soft-limit-link', '.facets-soft-limit-link')).each(function () {
        jQuery(this).on('click', function () {
          jQuery(this).toggleClass('up-arrow');
        });
      });
    }
  };

  let setNodeAddCurrency = function () {
    var typeElements = jQuery('.type .form-checkboxes > div:gt(2)');
    if (typeElements.length > 0) {
      typeElements.wrapAll('<div class="type-wrap"></div>');
    }

    var genreElements = jQuery('.genre .form-checkboxes > div:gt(2)');
    if (genreElements.length > 0) {
      genreElements.wrapAll('<div class="genre-wrap"></div>');
    }

    var languageElements = jQuery('.language .form-checkboxes > div:gt(2)');
    if (languageElements.length > 0) {
      languageElements.wrapAll('<div class="language-wrap"></div>');
    }

    var subLanguageElements = jQuery('.subtitle-language .form-checkboxes > div:gt(2)');
    if (subLanguageElements.length > 0) {
      subLanguageElements.wrapAll('<div class="subtitle-language-wrap"></div>');
    }

    var transLanguageElements = jQuery('.translation-language .form-checkboxes > div:gt(2)');
    if (transLanguageElements.length > 0) {
      transLanguageElements.wrapAll('<div class="trans-language-wrap"></div>');
    }
  }

  // redirect to slider on previous/next key

  if (jQuery('body.node--type-journey')) {
    document.onkeydown = function (event) {

      switch (event.keyCode) {
        case 37:

          if (jQuery('li.page-item a').length) {
            window.location.href = jQuery('li.page-item a').attr('href');
          }

          break;
        case 39:
          if (jQuery('li.pager__item--next a').length) {
            window.location.href = jQuery('li.pager__item--next a').attr('href');
          }
          break;
      }

    };
  }

  // set offset for guided journey slider
  var contentHeight = $('.template-info').height();
  if ($(window).width() >= 768) {
    window.addEventListener("load", function () {
      if (window.location.href.indexOf("#slider-nodes") > -1) {
        var body = $("html, body");
        body.stop().animate({ scrollTop: contentHeight + 200 }, 10, 'swing', function () {
        });
      }
    });
  }
  if ($(window).width() <= 767) {
    window.addEventListener("load", function () {
      if (window.location.href.indexOf("#slider-nodes") > -1) {
        var body = $("html, body");
        body.stop().animate({ scrollTop: contentHeight + 100 }, 50, 'swing', function () {
        });
      }
    });
  }

  if (jQuery(window).width() > 767) {
    var maxHeight = 0;
    jQuery(".support-card-wrapper .first-desc .description p").each(function () {
      if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
    });

    jQuery(".support-card-wrapper .first-desc .description p").height(maxHeight);

    var maxHeight1 = 0;
    jQuery(".support-card-wrapper .second-desc .description p").each(function () {
      if (jQuery(this).height() > maxHeight1) { maxHeight1 = jQuery(this).height(); }
    });

    jQuery(".support-card-wrapper .second-desc .description p").height(maxHeight1);
  }

  jQuery(window).resize(function () {
    if (jQuery(window).width() > 767) {
      var maxHeight = 0;
      jQuery(".support-card-wrapper .first-desc .description p").each(function () {
        if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
      });

      jQuery(".support-card-wrapper .first-desc .description p").height(maxHeight);

      var maxHeight1 = 0;
      jQuery(".support-card-wrapper .second-desc .description p").each(function () {
        if (jQuery(this).height() > maxHeight1) { maxHeight1 = jQuery(this).height(); }
      });

      jQuery(".support-card-wrapper .second-desc .description p").height(maxHeight1);
    }
  });
  jQuery(".mobile-show").find("#search-search").attr("id", "search-search-page");
  jQuery(".mobile-show").find("#edit-submit-search").attr("id", "edit-submit-search-page");
  jQuery(".mobile-show").find("#edit-keys").attr("id", "edit-keys-page");

  // Function to move search keys wrapper based on screen size
  function moveKeysWrapper() {
    // Select desktop and mobile search key elements
    var desktopWrapper = jQuery('.filter-wrapper.multiple-filter .title.detach-div.search-title-desktop');
    var mobileWrapper = jQuery('.more-filter-wrapper .search-title-mobile');

    // Check screen width for responsiveness
    if (jQuery(window).width() <= 767) {
      // For mobile view
      moveContent(desktopWrapper, mobileWrapper);
    } else {
      // For desktop view
      moveContent(mobileWrapper, desktopWrapper);
    }
  }

  // Function to move HTML content between elements
  function moveContent(sourceWrapper, targetWrapper) {
    // Move HTML content from source to target
    targetWrapper.html(sourceWrapper.html());

    // Move input field values from source to target
    sourceWrapper.find('input').each(function(index) {
      targetWrapper.find('input').eq(index).val(jQuery(this).val());
    });

    // Clear source content
    sourceWrapper.empty();
  }

  // Call moveKeysWrapper on load
  jQuery(document).ready(function() {
    moveKeysWrapper();
  });

})(jQuery, Drupal, once);

},{}]},{},[1])